const addressRegExp = /^\s*(address|add|addr|dirección|direccion|direción|street|calle)\s*$/i;
const postalCodeRegExp = /^\s*(postal[\s_-]*code|zip[\s_-]*code|postalcode|zipcode|pc|zc)\s*$/i;
const latitudeRegexp = /^\s*(latitude|lat|latitud|lat\.|y)\s*$/i;
const locationGroupCodeRegExp = /^\s*((zone|location)[\s_-]*)?group\s*$/i;
const longitudeRegExp = /^\s*(longitude|lng|lon|longitud|long|lng\.|lon\.|x)\s*$/i;
const countryRegExp = /^\s*(country|país|pais)\s*$/i;

export const LOCATIONS_COLUMNS = [
  {
    cpy: 'entityFileUpload.columnOptions.address',
    key: 'address',
    regexp: addressRegExp,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.cartographyLevel',
    key: 'cartographyLevelId',
    regexp: /^\s*(cartography\s*)?(level\s*(id)?)\s*$/i,
    require: true
  },
  {
    cpy: 'entityFileUpload.columnOptions.cartographyShapeId',
    key: 'cartographyShapeId',
    regexp: /^\s*(cartography\s*)?(shape\s*)(id\s*)?\s*$/i,
    require: true
  },
  {
    cpy: 'entityFileUpload.columnOptions.city',
    key: 'city',
    regexp: /^\s*city\s*$/i,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.country',
    key: 'country',
    regexp: countryRegExp,
    require: true
  },
  {
    cpy: 'entityFileUpload.columnOptions.latitude',
    key: 'latitude',
    regexp: latitudeRegexp,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.longitude',
    key: 'longitude',
    regexp: longitudeRegExp,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.province',
    key: 'province',
    regexp: /^\s*province\s*$/i,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.radiusFeet',
    key: 'radiusFeets',
    regexp: /^\s*radius[\s_-]*feets?\s*$/i,
    require: true
  },
  {
    cpy: 'entityFileUpload.columnOptions.radiusMeters',
    key: 'radiusMeters',
    regexp: /^\s*radius(\s*\(\s*meters?\s*\))?\s*$/i,
    require: true
  },
  {
    cpy: 'entityFileUpload.columnOptions.region',
    key: 'region',
    regexp: /^\s*region\s*$/i,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.syncId',
    key: 'syncId',
    regexp: /^\s*sync\s*id\s*$/i,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.locationType',
    key: 'locationType',
    regexp: /^\s*(location|zone)[\s_-]*type\s*$/i,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.locationName',
    key: 'zoneName',
    regexp: /^\s*((location|loc|zona|zone)[\s_-]*)?(name|nombre)\s*$/i,
    require: true
  },
  {
    cpy: 'entityFileUpload.columnOptions.postalCode',
    key: 'postalCode',
    regexp: postalCodeRegExp,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.locationGroup',
    key: 'zoneGroup',
    regexp: locationGroupCodeRegExp,
    require: false
  }
];

export const VENUE_COLUMNS = [
  {
    cpy: 'entityFileUpload.columnOptions.country',
    key: 'country',
    regexp: countryRegExp,
    require: true
  },
  {
    cpy: 'entityFileUpload.columnOptions.brandOrCategoryV2',
    key: 'point_type',
    regexp:
      /^\s*(?:brand|category|marca|categoría|categoria|sector|industria|brand[\s_-]*or[\s_-]*category|marca[\s_-]*o[\s_-]*categoría|marca[\s_-]*o[\s_-]*categoria)\s*$/i,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.address',
    key: 'address',
    regexp: addressRegExp,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.latitude',
    key: 'latitude',
    regexp: latitudeRegexp,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.longitude',
    key: 'longitude',
    regexp: longitudeRegExp,
    require: false
  },
  {
    cpy: 'entityFileUpload.columnOptions.venueNameV2',
    key: 'venueName',
    regexp: /^\s*(venue[\s_-]*)?(name|nombre|tienda)\s*$/i,
    require: true
  },
  {
    cpy: 'entityFileUpload.columnOptions.venueGroupV2',
    key: 'venueGroup',
    regexp: /^\s*venue[\s_-]*groups?\s*$/i,
    require: false
  }
];
